import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetPromotionLogsById(club, url) {
  var url = "/reservation/get_promotion_logs/" + club + url;

  return FetchGetDataWithAuthNEW(url);
}
